export enum ImagePath {
  TESTAMENTS = 'testaments',
  USERS = 'users',
  ECOMMERCE = 'e-commerce',
  PROFILE = 'profile',
  BLOG = 'blog',
}

// ==============================|| NEW URL - GET IMAGE URL ||============================== //

export function getImageUrl(name: string, path?: string) {
  console.log({ name, path });
  console.log(new URL(`/src/assets/images/${path ? path + '/' : ''}${name}`, import.meta.url).href);
  return new URL(`/src/assets/images/${path ? path + '/' : ''}${name}`, import.meta.url).href;
}
